import React, {useState} from 'react';
import {
    Box,
    Collapse,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
} from '@mui/material';
import config, {DrawerMenuI} from '../../assets/config';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../store/reduxHooks';
import {ExpandLess, ExpandMore} from '@mui/icons-material';
import {setDrawer} from '../../store/uxSlice';

const drawerWidth = 240;

export default function (props: any) {
    const {drawerOpen} = useAppSelector((state) => state.ux);
    const {user} = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsedData, setCollapsed] = useState<any>({
        'drawer-section-event': true,
        'drawer-section-app': true,
    });

    const collapedChange = (itemId: string, value: boolean) => {
        setCollapsed({...collapsedData, [itemId]: value});
    };

    const DrawerContent = () => (
        <>
            <Toolbar/>
            <Box
                sx={{
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    minWidth: '250px',
                }}
                mt={2}
            >
                <Box>
                    <List>
                        {config.drawerMenuTop.map((item: DrawerMenuI) => {
                            if (user.role === 'ADMIN' || !['drawer-top-organizers'].includes(item.id)) {
                                return (
                                    <Box key={item.id}>
                                        <ListItem disablePadding>
                                            <ListItemButton
                                                selected={location.pathname === item.route}
                                                onClick={() => {
                                                    if (item.children) {
                                                        collapedChange(item.id, !collapsedData[item.id]);
                                                    } else {
                                                        dispatch(setDrawer(false));
                                                        navigate(item.route);
                                                    }
                                                }}
                                            >
                                                <ListItemIcon sx={{color: 'text.primary'}}>
                                                    {item.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={item.label}/>
                                                {item.children && (
                                                    <>
                                                        {collapsedData[item.id] ? (
                                                            <ExpandLess/>
                                                        ) : (
                                                            <ExpandMore/>
                                                        )}
                                                    </>
                                                )}
                                            </ListItemButton>
                                        </ListItem>
                                        {item.children &&
                                            collapsedData[item.id] &&
                                            (item.children || []).map(
                                                (childItem: DrawerMenuI, idx: number) => {
                                                    if (
                                                        (childItem.id === 'drawer-top-faq' && user.role === 'ADMIN') ||
                                                        (childItem.id === 'drawer-top-pages' && user.role === 'ADMIN') ||
                                                        (childItem.id === 'drawer-top-venue' && user.role === 'ADMIN') ||
                                                        (childItem.id !== 'drawer-top-pages' && childItem.id !== 'drawer-top-faq'
                                                            && childItem.id !== 'drawer-top-venue')
                                                    ) {
                                                        return (
                                                            <Collapse
                                                                key={`${item.id}-${idx}`}
                                                                in={collapsedData[item.id]}
                                                                timeout='auto'
                                                                unmountOnExit
                                                            >
                                                                <List component='div' disablePadding>
                                                                    <ListItemButton
                                                                        sx={{pl: 4}}
                                                                        selected={location.pathname === childItem.route}
                                                                        onClick={() => {
                                                                            dispatch(setDrawer(false));
                                                                            navigate(childItem.route);
                                                                        }}
                                                                    >
                                                                        <ListItemIcon>{childItem.icon}</ListItemIcon>
                                                                        <ListItemText primary={childItem.label}/>
                                                                    </ListItemButton>
                                                                </List>
                                                            </Collapse>
                                                        );
                                                    } else {
                                                        // If the conditions are not met, you can return null or an empty element
                                                        return null;
                                                    }
                                                }
                                            )}
                                    </Box>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </List>
                </Box>
                <Box sx={{flexGrow: 1}}/>
                <Box>
                    <Divider/>
                    <List>
                        {config.drawerMenuBottom.map((item: any) => (
                            <ListItem key={item.id} disablePadding>
                                <ListItemButton
                                    selected={location.pathname === item.route}
                                    onClick={() => {
                                        dispatch(setDrawer(false));
                                        navigate(item.route);
                                    }}
                                >
                                    <ListItemIcon sx={{color: 'text.primary'}}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={item.label}/>
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Box>
        </>
    );

    return (
        <>
            <Drawer
                variant='permanent'
                ModalProps={{
                    keepMounted: true,
                    onClose: () => dispatch(setDrawer(false)),
                }}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    // [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                    display: {
                        xs: 'none',
                        md: 'block',
                    },
                }}
            >
                <DrawerContent/>
            </Drawer>
            <Drawer
                open={drawerOpen}
                variant='temporary'
                ModalProps={{
                    keepMounted: true,
                    onClose: () => dispatch(setDrawer(false)),
                }}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    // [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                    display: {
                        xs: 'block',
                        md: 'none',
                    },
                }}
            >
                <DrawerContent/>
            </Drawer>
        </>
    );
}
